import { C2Text, C3Text, C5Text } from "../../../common/components/text/CustomText";
import { Column, Divider, Row, SizedBox } from "../../../common/components/CommonBaseComponents";
import CustomImage from "../../../common/components/image/CustomImage";
import Translate from "../../../common/translate/Translate";
import { Theme } from "../../../common/Theme";

function RevenueDetailDeviceCard({ deviceName, regularCycle, courtesyCycle }) {
    let imageName;
    let backgroundColor;

    if (deviceName === "washer") {
        imageName = "image_washer";
        backgroundColor = Theme.color.cyan500_01;
    } else if (deviceName === "dryer") {
        imageName = "image_dryer";
        backgroundColor = Theme.color.red400_01;
    } else if (deviceName === "combo") {
        imageName = "image_combo";
        backgroundColor = Theme.color.indigo500_01;
    }

    return (
        <Row width={"100%"} justifyContent={"flex-start"} alignItem={"flex-start"} gap={"12px"}>
            <SizedBox width={"64px"} height={"64px"} backgroundColor={backgroundColor} borderRadius={"8px"}>
                <CustomImage imageName={imageName} width={"29px"} height={"36px"} />
            </SizedBox>
            <Column flex={"1"} justifyContent={"flex-start"} alignItem={"flex-start"}>
                <C3Text fontWeight={"500"}>{Translate(`common.${deviceName}`)}</C3Text>
                <SizedBox height={"6px"} />
                <Row justifyContent={"space-between"} width={"100%"}>
                    <C5Text fontColor={Theme.color.gray500}>{Translate("store.revenueChart.regularCycle")}</C5Text>
                    <C3Text fontColor={Theme.color.zinc850} fontWeight={"600"}>
                        {regularCycle}
                    </C3Text>
                </Row>
                <SizedBox height={"4px"} />
                <Row justifyContent={"space-between"} width={"100%"}>
                    <C5Text fontColor={Theme.color.gray500}>{Translate("store.revenueChart.courtesyCycle")}</C5Text>
                    <C3Text fontColor={Theme.color.zinc850} fontWeight={"600"}>
                        {courtesyCycle}
                    </C3Text>
                </Row>
            </Column>
        </Row>
    );
}

function RevenueDetailCard({
    label = "-",
    totalRegularCycle = 0,
    totalCourtesyCycle = 0,
    washer = { regularCycle: 0, courtesyCycle: 0 },
    dryer = { regularCycle: 0, courtesyCycle: 0 },
    combo = { regularCycle: 0, courtesyCycle: 0 },
}) {
    return (
        <SizedBox width={"245px"} height={"334px"} alignItem={"flex-start"} justifyContent={"flex-start"}>
            <C2Text fontColor={Theme.color.zinc850}>{label}</C2Text>
            <SizedBox height={"10px"} />
            <Row justifyContent={"space-between"} width={"100%"}>
                <C3Text>{Translate("store.revenueDetail.totalRegularCycle")}</C3Text>
                <C2Text fontColor={Theme.color.zinc850} fontWeight={"600"}>
                    {totalRegularCycle}
                </C2Text>
            </Row>
            <SizedBox height={"6px"} />
            <Row justifyContent={"space-between"} width={"100%"}>
                <C3Text>{Translate("store.revenueDetail.totalCourtesyCycle")}</C3Text>
                <C2Text fontColor={Theme.color.zinc850} fontWeight={"600"}>
                    {totalCourtesyCycle}
                </C2Text>
            </Row>
            <Divider marginTop={"12px"} marginBottom={"16px"} />
            <RevenueDetailDeviceCard
                deviceName={"washer"}
                regularCycle={washer.regularCycle}
                courtesyCycle={washer.courtesyCycle}
            />
            <SizedBox height={"18px"} />
            <RevenueDetailDeviceCard
                deviceName={"dryer"}
                regularCycle={dryer.regularCycle}
                courtesyCycle={dryer.courtesyCycle}
            />
            <SizedBox height={"18px"} />
            <RevenueDetailDeviceCard
                deviceName={"combo"}
                regularCycle={combo.regularCycle}
                courtesyCycle={combo.courtesyCycle}
            />
        </SizedBox>
    );
}

export default RevenueDetailCard;
